module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-coin_42x46.png?v=e91fc81a";